import { render } from "./operationTrail.vue?vue&type=template&id=66940990&scoped=true&ts=true"
import script from "./operationTrail.vue?vue&type=script&lang=ts"
export * from "./operationTrail.vue?vue&type=script&lang=ts"

import "./operationTrail.vue?vue&type=style&index=0&id=66940990&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66940990"]])

export default __exports__